export default "__VITE_ASSET__D$AAyK6i__"